import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=0afefbde&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0afefbde', component.options)
    } else {
      api.reload('0afefbde', component.options)
    }
    module.hot.accept("./VerDetalleModal.vue?vue&type=template&id=0afefbde&", function () {
      api.rerender('0afefbde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Clientes/VerDetalleModal.vue"
export default component.exports